import React from "react";
import { Link } from "react-router-dom";

function StatusBadge({ status }) {
  const styles = {
    confirmed: { color: "#10b981", bg: "rgba(16,185,129,0.1)", border: "rgba(16,185,129,0.25)" },
    upcoming:  { color: "#60a5fa", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.25)"  },
  };
  const s = styles[status] || styles.confirmed;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.8px",
      padding: "4px 10px", borderRadius: 100,
      color: s.color, background: s.bg, border: `1px solid ${s.border}`,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: s.color, display: "inline-block" }} />
      {status}
    </span>
  );
}

function BookingCard({ booking, index }) {
  const date = new Date(booking.bookedAt).toLocaleDateString("en-IN", {
    day: "numeric", month: "short", year: "numeric",
  });

  return (
    <div className="page-card" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="booking-card-top">
        <div className="booking-ref-block">
          <div className="booking-ref">{booking.ref}</div>
          <div className="booking-date">Booked on {date}</div>
        </div>
        <StatusBadge status="confirmed" />
      </div>

      <div className="booking-route">
        <div className="br-point">
          <div className="br-code">{booking.fromCode}</div>
          <div className="br-city">{booking.from}</div>
          <div className="br-time">{booking.departure}</div>
        </div>
        <div className="br-mid">
          <div className="br-airline">{booking.airline}</div>
          <div className="br-track">
            <div className="br-dot" />
            <div className="br-dash" />
            <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--accent-light)">
              <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19 4c-2 0-4 1-3.5 2.5L12 10 4.8 6.2c-.5-.3-1.1 0-1.2.5L3 8c-.1.5.2 1 .7 1.2L9 11.5 6.5 14H4l-1 2 2 1 1-2h2.5L11.5 17.5l-2.5.8c-.4.1-.7.6-.7 1.1l.2 1.2c.1.5.7.8 1.2.5L19 16l-.2 3.2z"/>
            </svg>
            <div className="br-dash" />
            <div className="br-dot" />
          </div>
          <div className="br-duration">{booking.duration}</div>
        </div>
        <div className="br-point br-point--right">
          <div className="br-code">{booking.toCode}</div>
          <div className="br-city">{booking.to}</div>
          <div className="br-time">{booking.arrival}</div>
        </div>
      </div>

      <div className="booking-card-footer">
        <div className="bc-detail">
          <span className="bc-label">Passenger</span>
          <span className="bc-val">{booking.passenger.name}</span>
        </div>
        <div className="bc-detail">
          <span className="bc-label">Flight</span>
          <span className="bc-val mono">{booking.code}</span>
        </div>
        <div className="bc-detail">
          <span className="bc-label">Class</span>
          <span className="bc-val">{booking.class}</span>
        </div>
        <div className="bc-detail bc-detail--right">
          <span className="bc-label">Total Paid</span>
          <span className="bc-val bc-val--price mono">₹{booking.total.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}

function MyBookings({ bookings }) {
  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-h1">My Bookings</h1>
          <p className="page-desc">All your confirmed flight reservations in one place.</p>
        </div>
        {bookings.length > 0 && (
          <div className="page-badge">
            {bookings.length} booking{bookings.length !== 1 ? "s" : ""}
          </div>
        )}
      </div>

      {bookings.length === 0 ? (
        <div className="page-empty">
          <div className="page-empty-icon">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
            </svg>
          </div>
          <h3 className="page-empty-title">No bookings yet</h3>
          <p className="page-empty-sub">Head to the dashboard to search and book your first flight.</p>
          <Link to="/" className="page-empty-cta">Search Flights →</Link>
        </div>
      ) : (
        <div className="page-cards-list">
          {bookings.map((b, i) => (
            <BookingCard key={b.ref} booking={b} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}

export default MyBookings;